module.exports = __webpack_public_path__ + "img/slim_cleanstation21.481e1f13.jpg";